import { defineTextStyles } from "@chakra-ui/react";

export const textStyles = defineTextStyles({
  emphasisText: {
    description: "This text style is used for emphasis  in headings.",
    value: {
      fontFamily: "Sansita Swashed",
    },
  },
});
